import { Globals } from '../shared/globals';
import { Injectable } from '@angular/core';
import {
  JsonObject,
  JsonProperty,
  JsonSerializer,
} from 'typescript-json-serializer';
import { Api } from '../shared/api';

@JsonObject()
export class StationInformation {
  @JsonProperty('NumberOfPhases') numberOfPhases: number;
  @JsonProperty('DefaultPhase') defaultPhase: number;
  @JsonProperty('AvailableCurrents') availableCurrents: Array<number>;
  @JsonProperty('DefaultStartCurrent') defaultStartCurrent: number;
  @JsonProperty('DefaultMaxCurrent') defaultMaxCurrent: number;
  @JsonProperty('SupportsRephasing') supportsRephasing: boolean;
}

@JsonObject()
export class StationSubtype {
  @JsonProperty('Id') id: number;
  @JsonProperty('Name') name: string;
  @JsonProperty('StationInformation') stationInformation: StationInformation;
}

@Injectable()
export class StationSubtypeService {
  private readonly jsonSerializer = new JsonSerializer();
  private subtypesUrl: string;

  constructor(private readonly api: Api, private readonly globals: Globals) {
    this.subtypesUrl = this.globals.apiUrl(`stations/subtypes`);
  }

  public async getStationSubtypes(): Promise<StationSubtype[]> {
    const response: string = await this.api.httpGet(this.subtypesUrl);
    return this.jsonSerializer.deserializeObjectArray(response, StationSubtype);
  }
}
